import { BaseEntity } from "yt-ng-framework";

export class KomitentUgovor extends BaseEntity{
    constructor(){
        super();
    }

    OrgJedID: number = null;
    PodVrstaDokumentaStavkaID: number = null;
    KomitentID: number = null;
    Datum: Date = null;
    OdDatuma: Date = null;
    DoDatuma: Date = null;
    BrojDokumenta: string = null;
    Url: string = null;
    BrojDokumenta2: string = null;

    Deserialize(input: any){
        this.ID = input.ID;
        this.OrgJedID = input.OrgJedID;
        this.PodVrstaDokumentaStavkaID = input.PodVrstaDokumentaStavkaID;
        this.KomitentID = input.KomitentID;;
        this.Datum = input.Datum;
        this.OdDatuma = input.OdDatuma;
        this.DoDatuma = input.DoDatuma;
        this.BrojDokumenta = input.BrojDokumenta;
        this.BrojDokumenta2 = input.BrojDokumenta2;
        return this;
    }

    Serialize(input: KomitentUgovor) {
        return input;
    }
}